// Global Error Messages

export const ERROR_LIST = {
  ERROR_FETCH_DATA: "There was a problem fetching the data",
  ALARM_SUMMARY_EMPTY_DATA: "There are no alarms to display at this time.",
  NO_EVENTS: "There are no events available at this time.",
  NO_RECORDS: "There are no records available at this time.",
  NO_DATA: "There is no data available at this time.",
  NO_NOTIFICATIONS: "There are no new notifications at this time.",
  NO_CRITICAL_ALERTS: "There are no critical alerts to display at this time.",
  WAIT: "Please wait while data loading...",
  MAP_NOT_LOADED: "Map cannot be loaded right now, sorry."
};

export const ERROR_LISTOfAsset = {
  ERROR_FETCH_DATA: `There was a problem fetching the data`,
  ASSET_SUMMARY_EMPTY_DATA: `No data available for the selected device/substation.`,
  NO_EVENTS: `There are no events available at this time.`,
  NO_RECORDS: `There are no records available at this time.`,
  NO_DATA: `There is no data available at this time.`,
  NO_NOTIFICATIONS: `There are no new notifications at this time.`,
};

export const ERROR_LISTLogin = {
  ERROR_FETCH_DATA: "Failed to load user login data.",
  LOGIN_SUMMARY_EMPTY_DATA: "No data available for the selected device/substation.",
};
